import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Loader from "../../Common/Loader";
import { DASHBOARD_CLIENT_DETAIL_EQUITY } from "../../../Configuration/API_URL";
import {
  AESEncryption,
  ApiResDecrypt,
  noDataFound,
} from "../../../CommonMethhods/CommonMethods";
import { Constants } from "../../../CommonMethhods/Constants";
import axiosInstance from "../../../CommonMethhods/axiosInstance";

function PortfolioOverviewGainers() {
  const storeToken = localStorage.getItem("ssoToken");
  const [portfolioGain, setPortfolioGain] = useState([]);
  const [gainerSymbol, setGainerSymbol] = useState();
  const [gainerValue, setGainerValue] = useState();
  const [loader, setLoader] = useState(true);
  const [serverError, setServerError] = useState("");

  let clientCode = "";
  const getPortfolioGainer = async (clientCode) => {
    let payloadValue = { ClientCode: clientCode };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetails = await axiosInstance.post(
        DASHBOARD_CLIENT_DETAIL_EQUITY.PortfolioOverview_URL,

        `"${encPayload}"`,
      );
      const response = ApiResDecrypt(getDetails?.data);
      const res = response.data.Gainers;
      setPortfolioGain(res);
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
      setServerError("Something went wrong, Please try again later.");
    }
  };
  useEffect(() => {
    if (localStorage.getItem("clientCode")) {
      clientCode = localStorage.getItem("clientCode");
      getPortfolioGainer(clientCode);
    } else {
      setLoader(false);
    }
  }, []);

  const barChartData = () => {
    const symbol = [];
    const value = [];
    portfolioGain.length > 0 &&
      portfolioGain.map((item) => {
        symbol.push(item.Symbol);
        value.push(item.value);
      });
    setGainerSymbol(symbol);
    setGainerValue(value);
  };
  useEffect(() => {
    barChartData();
  }, [portfolioGain]);
  const portfolioGainer = {
    credits: {
      enabled: false,
    },
    chart: {
      type: "bar",
    },
    title: {
      text: null,
    },
    xAxis: {
      gridLineWidth: 0,
      categories: gainerSymbol,
      title: {
        text: null,
      },
    },
    yAxis: {
      min: 0,

      // gridLineWidth: 0,

      title: {
        text: null,

        align: "high",
      },

      labels: {
        // enabled: false,
        overflow: "justify",
      },
    },
    tooltip: {
      pointFormat: `{series.name}: <b>{point.y:.2f}</b>`,
    },
    plotOptions: {
      bar: {
        pointWidth: 40,
        pointHeight: 40,
        dataLabels: {
          enabled: false,
        },
      },
    },

    legend: {
      enabled: false,
    },

    // tooltip: {
    //   enabled: false,
    // },

    series: [
      {
        name: "",
        data: gainerValue,
      },
    ],
  };
  return (
    <>
      <div className="col-12 col-md-6 gainers">
        <div className="card-box graph">
          <div className="card-title">
            <h2 className="small-title">{Constants.Portfolio_Gainers}</h2>
          </div>
          {loader ? (
            <div className="loader-alignment">
              <Loader />
            </div>
          ) : (
            <div className="section-graph1">
              {portfolioGain.length > 0 ? (
                <HighchartsReact
                  highcharts={Highcharts}
                  options={portfolioGainer}
                />
              ) : serverError ===
                "Something went wrong, Please try again later." ? (
                <h4 className="no-data">{serverError}</h4>
              ) : (
                noDataFound()
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default PortfolioOverviewGainers;
